import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class CancelShipmentReasonsFilterEntity {
  role?: RoleType
}
